export default __webpack_public_path__ + "static/media/EM1780.34I-43304_-25927_0.c9e4a0ad.jpg";